module.exports = __webpack_public_path__ + "img/cloud-arrow-up-fill.3cadb415.svg";